const Fingerprint2 = require("fingerprintjs2");

export const fingerprint = callback => {
  if (window.requestIdleCallback) {
    requestIdleCallback(function() {
      Fingerprint2.get(function(components) {
        var values = components.map(function(component) {
          return component.value;
        });
        var murmur = Fingerprint2.x64hash128(values.join(""), 31);
        callback(murmur);
      });
    });
  } else {
    setTimeout(function() {
      Fingerprint2.get(function(components) {
        var values = components.map(function(component) {
          return component.value;
        });
        var murmur = Fingerprint2.x64hash128(values.join(""), 31);
        callback(murmur);
      });
    }, 500);
  }
};
